























import { mapGetters, mapState } from 'vuex'
import { mapDeps } from '~/plugins/dependency-container/utils'
import { USER_NS } from '~/store/modules/shared/user/state'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { Specification } from '~/models/classified/types'
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons'
import SpecificationEntry from '~/components/plot/classifieds/view/partials/SpecificationEntry.vue'
import SpecificationViewService from '~/services/SpecificationViewService'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: {
    CCard,
    SpecificationEntry
  },
  props: {
    specifications: { type: Array, required: true },
    extraSpecifications: {
      type: Array,
      required: false,
      default() {
        return []
      }
    }
  },
  computed: {
    ...mapGetters(USER_NS, {
      userIsAdmin: 'isAdmin'
    }),
    ...mapState(CLASSIFIED_VIEW_NS, {
      seller: state => state.seller
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, [
      'sellerIsBlacklistedSuspiciousOrFraudster'
    ]),
    ...mapDeps({ specificationViewService: SpecificationViewService }),
    icons: () => ({
      shoppingCart: faShoppingCart
    }),
    allSpecifications(): Specification[] {
      const hardcodedSpecifications = [] // use this to add hardcoded specs

      if (
        !this.sellerIsBlacklistedSuspiciousOrFraudster &&
        (this.seller.extra_telephone || this.seller.telephone1)
      ) {
        const telephoneSpec = {
          name: 'telephone',
          label: this.$t('telephone'),
          value: this.seller.extra_telephone || this.seller.telephone1,
          extra_name: this.seller.extra_name || null
        }
        hardcodedSpecifications.push(telephoneSpec)
      }
      return [
        ...(this.specifications as any),
        ...(this.extraSpecifications as any),
        ...(hardcodedSpecifications as any)
      ].filter(specification => {
        return specification.value !== null
      })
    },
    column1(): Specification[] {
      const endIndex = Math.ceil(this.allSpecifications.length / 2)
      const cloneArray = [...this.allSpecifications]
      return cloneArray.splice(0, endIndex)
    },
    column2(): Specification[] {
      const startIndex = this.column1.length
      const cloneArray = [...this.allSpecifications]
      return cloneArray.splice(startIndex, this.allSpecifications.length - 1)
    }
  }
})
